module.exports = __webpack_public_path__ + "static/img/icon-success-green.1e0881e0.png";